import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PreviewIcon from '@mui/icons-material/Preview';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ViewDocx from './ViewDocx'
import ConfirmationDialog from './ConfirmationDialog'
import RefreshIcon from '@mui/icons-material/Refresh';
import Modal from '@mui/material/Modal';
import {  useParams } from 'react-router-dom';
import { useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorIcon from '@mui/icons-material/Error';
import AddTaskIcon from '@mui/icons-material/AddTask';
import BugReportIcon from '@mui/icons-material/BugReport';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import { DataGrid, GridColDef, GridToolbar, gridDateComparator } from '@mui/x-data-grid';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import CaseFacts from './CaseFacts'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
import { JsonEditor } from 'json-edit-react'
import { HOST } from '../components/config';

const TransformerResultDetail = (props) => {
  const { caseId } = useParams();
  const assemblyTransformerId = props.assemblyTransformerId;
  const assemblyCaseDocumentId = props.assemblyCaseDocumentId;
  const assemblyCaseDocumentName = props.assemblyCaseDocumentName;

  const [showOutput, setShowOutput] = useState(false)
  const [previewUrl, setPreviewUrl] = useState(null); 
  const [previewType, setPreviewType] = useState(null); 
  
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '80%',
  border: '1px solid grey[200]',
  boxShadow: '0 4px 12px rgb(0 0 0 / 0.2)',
  bgcolor: 'background.paper',
    borderRadius: 2,
    p: 4,
  };
  
  const submodalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '50%',
  border: '1px solid grey[200]',
  boxShadow: '0 4px 12px rgb(0 0 0 / 0.2)',
  bgcolor: 'background.paper',
    borderRadius: 2,
    p: 4,
  };

  const [results, setResults] = useState([]);
  const [resultRuns, setResultRuns] = useState([]);
  const [resultInfo, setResultInfo] = useState([]);
  const [transformerInfo, setTransformerInfo] = useState([]);
  const [inputDocumentsInfo, setInputDocumentsInfo] = useState({});
  const [pendingResultToDeleteId, setPendingResultToDeleteId] = useState(null);
  const [pendingOutputViewResultJson, setPendingOutputViewResultJson] = useState(null);

  const fetchTransformer = (file_id) => {
    fetch(HOST + '/api/assembly_transformers/'+ assemblyTransformerId,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setTransformerInfo(json)
      json.input_assembly_document_ids.map((doc_id) => fetchInputDocument(doc_id) ) 
   })
  }
  const fetchInputDocument = (assembly_doc_id) => {
    fetch(HOST + '/api/assembly_documents/'+ assembly_doc_id,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setInputDocumentsInfo((prevState) => ({...prevState, [assembly_doc_id]: json })   )
   })
  }
  const handleRunDownload = async (run_id) => {
      try {
        const response = await fetch(HOST + '/api/file_processing_step_result_runs/' + run_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        if (download_url){
          window.open(download_url, '_blank')
        }
      } catch (err) {
      }   
    };
 
  const handlePreviewFile = async(file_id) => {
      console.log("set preview")
      try {
        const response = await fetch(HOST + '/api/files/' + file_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        setPreviewUrl(download_url)
        setPreviewType("pdf")
      } catch (err) {
      }   
  }

  const fetchResults = () => {
    fetch(HOST + '/api/assembly_transformer_results?assembly_case_document_id=' + assemblyCaseDocumentId +'&assembly_transformer_id='+assemblyTransformerId,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setResults(json)
   })
  }
  useEffect( () => {
    fetchTransformer()
  }, []);

  const handleDeleteResult = (result_id) => {
    fetch(HOST + '/api/assembly_transformer_results/' + result_id + "/",
    {   
      "method": "DELETE",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => fetchResults() || setPendingResultToDeleteId(null))
  }
  
  const handleRerunAllTransformers = () => {
    fetch(HOST + '/api/assembly_transformers/' + assemblyTransformerId + '/process_all/?assembly_case_document_id=' + assemblyCaseDocumentId, 
    {   
      "method": "POST",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      fetchResults()
   })
  }
  
  const handleRerunErrored = () => {
    results.map((result) => {
      if (result.status == 'ERROR') {
        handleRerunTransformer(result.id)
      }
    })
  }

  const handleRerunTransformer = (result_id) => {
    fetch(HOST + '/api/assembly_transformer_results/' + result_id + "/reprocess/?=",
    {   
      "method": "POST",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      fetchResults()
   })
  }
  
  useEffect( () => {
    fetchResults() 
    
    const intervalId = setInterval(fetchResults, 5000); // Poll every 5 seconds
    
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
    };
  }, []);

  const onCancel = props.onCancel;
  const onUpload = props.onUpload;
  
  const paginationModel = { page: 0, pageSize: 10 };
  
  const getStatusChip = (item) => { return(item.status == 'SUCCESS' ? 
        (<Chip  className="chip-boxy"  label="Success" color="success" variant="" />) : 
        item.status.includes('ERROR') ?  
        (<Chip  className="chip-boxy" label={item.status} color="error" variant="" />) :
        item.status.includes('PREPARE') ?  
        (<Chip  className="chip-boxy"  label="Waiting to run" color="warning" variant="" />) : 
        (<Chip  className="chip-boxy"  label="Running" color="info" variant="" />)) 
  }
  
  const runColumns: GridColDef[] = [
    { 
      field: 'updated_at', 
      headerName: 'Updated At', 
      width: 200,
      sortComparator: gridDateComparator, 
      type: 'datetime',
      valueFormatter: (d_s) => d_s.toLocaleString(),
      valueGetter: (value, row) => new Date(row.updated_at)
    },
    ...(transformerInfo && transformerInfo.runs_per_file ? [{ 
      field: 'File', 
      visible: false,
      headerName: 'File', 
      width: 290,
      renderCell: (params) => params.row.file_name 
    }] : []),
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 100,
      renderCell: (params) => getStatusChip(params.row) 
    },
    {
      field: 'action',
      headerName: 'Actions',
      sortable: false,
      width: 250,
      renderCell: (params) =>  (
      <>
        <IconButton onClick={() => handleRerunTransformer(params.row.id)}
          size='md' >
          <RefreshIcon /> 
        </IconButton> 
        
        <IconButton onClick={() => setPendingOutputViewResultJson(params.row.output)}
          disabled={!params.row.output || Object.keys(params.row.output).length == 0}
          size='md' >
          <DataObjectIcon />
        </IconButton> 
        <IconButton onClick={() => setPendingOutputViewResultJson(params.row.error)}
          disabled={!params.row.error}
          size='md' >
          <BugReportIcon />
        </IconButton> 
        <IconButton onClick={() => handlePreviewFile(params.row.file_id)}
          size='md' >
          <PreviewIcon />
        </IconButton> 
        <IconButton onClick={() => setPendingResultToDeleteId(params.row.id)}
          size='md' >
          <DeleteIcon />
        </IconButton> 
    </>)
    },
  ];
  const resultDeleteConfirmation = pendingResultToDeleteId ? <ConfirmationDialog 
                                                        title="Confirm Result Deletion"
                                                        confirmButton="Delete"
                                                        message="Are you sure you want to delete this result?"
                                                        onCancel={ () => setPendingResultToDeleteId(null)} 
                                                        onConfirm={ () => handleDeleteResult(pendingResultToDeleteId)} /> : <></>
  
  const stylePreviewer = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  display:'block',
  overflow:'scroll',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '90%',
  bgcolor: 'background.paper',
  border: '1px solid grey[200]',
  boxShadow: '0 4px 12px rgb(0 0 0 / 0.2)',
  bgcolor: 'background.paper',
    borderRadius: 2,
  p: 4,
};
  const firstResult = results[0]
  const lastResultUpdatedAt = results.map((item) => item.updated_at).sort().pop()
  const docxPreviewer = <ViewDocx docUrl={previewUrl} docType={previewType}/>
  const format_date = (d) => (new Date(d)).toLocaleString()
  const isProcessing = results.filter((item) => item.status == 'PROCESSING').length > 0
  const hasError = results.filter((item) => item.status.includes('ERROR')).length > 0
  const humanizeUnderscores = (item) => item.split("_").map((x) => x.charAt(0).toUpperCase() + x.slice(1)).join(' ')
  const runningCount = results.filter((item) => item.status  == 'PROCESSING').length
  const successCount = results.filter((item) => item.status  == 'SUCCESS').length
  const errorCount = results.filter((item) => item.status.includes('ERROR')).length
  return (<Box sx={{ width: "100%"}}>
  <Box fullWidth >
      {resultDeleteConfirmation}
        { pendingOutputViewResultJson &&
          <Modal  open={pendingOutputViewResultJson}
          onClose={() => setPendingOutputViewResultJson(null) }
          >
        <Box sx={modalStyle} >
          <JsonEditor
    data={ pendingOutputViewResultJson}
    />
        </Box>
        </Modal>
        }
      {transformerInfo && transformerInfo.input_assembly_document_ids && transformerInfo.input_assembly_document_ids.length >0 &&
          <Box>
            {results.length == 0 &&
              <Alert sx={{}} severity="warning">{"Take a moment to review documents and facts below that will serve as context for this processor."}</Alert>
            }
            {results.length > 0 && !isProcessing && !hasError &&
              <Alert sx={{}} severity="warning">{"Click the button below if you would like to run the processor again on the new context."}</Alert>
            }
            { isProcessing &&
              <Alert sx={{}} severity="info">{"Processor may take a few minutes to complete."}</Alert>
            }
            { hasError &&
              <Alert sx={{}} severity="error">{"An error occurred during the last processing attempt."}</Alert>
              
            }
            {!props.hideDetails &&
              <>
                <h3>1. Review Facts</h3>
                <CaseFacts context={true} showOutput={true} preview={true} caseId={caseId} docIdFilter={transformerInfo.input_assembly_document_ids} /> 
                <h3>2. Review Documents</h3>
                <CaseFacts context={false} preview={true} caseId={caseId} docIdFilter={transformerInfo.input_assembly_document_ids} /> 
              </>
            }
            </Box>
        }
        {transformerInfo.runs_per_file &&
          <>
            <Typography sx={{p: 1 }}>
              Processes "{humanizeUnderscores(transformerInfo.type_filter)}" client files. 
            </Typography>
            {results.length == 0 &&  
              <Alert sx={{}} severity="warning">{"Waiting for relevant files to process. Upload a " + humanizeUnderscores(transformerInfo.type_filter) + " to run this processor."} </Alert>
            }
          </>
        }
      { !transformerInfo.runs_per_file &&  firstResult && !props.hideDetails &&
          <>
            <h3>
              {'4. '}Review Result&nbsp;{getStatusChip(firstResult)}
              <IconButton 
                size='md' 
                onClick={() => setShowOutput(showOutput ? false : true)}> 
                  {showOutput ? <KeyboardArrowDownIcon />: <KeyboardArrowUpIcon />}
              </IconButton> 
            </h3>
            <Collapse in={showOutput} >
              {firstResult.error != null &&
                <>
                      <JsonEditor
                data={ firstResult.error}
                />
                </>
              }
              {firstResult.output != null &&
                <JsonEditor
                  data={ firstResult.output}
                />
              }
          </Collapse>
          </>
      }
      { transformerInfo.runs_per_file && !props.hideDetails && 
        <>
          <h3>
            Output:
              
              <Button 
                size='small' 
                color='secondary'
                sx={{ m: 1}}
                variant='contained'
                onClick={() => setShowOutput(showOutput ? false : true)}> 
                  {showOutput ? <>Hide <KeyboardArrowDownIcon /> </>: <>Expand <KeyboardArrowUpIcon /></>}
              </Button> 
          </h3>
            <Collapse in={showOutput} >
              <DataGrid
                rows={results}
                columns={runColumns}
                initialState={{ sorting: { sortModel: [ { field: "updated_at", sort: 'desc' }]}, pagination: { paginationModel } }}
                pageSizeOptions={[10, 25, 50, 100]}
                disableColumnSelector
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    printOptions: { disableToolbarButton: true },
                    csvOptions: { disableToolbarButton: true },
                    showQuickFilter: true,
                  },
                }}
                sx={{ border: 0 }}
              />
            </Collapse>
        </>
      }
    {!props.hideDetails &&
      <h3>{transformerInfo.runs_per_file || props.hideDetails ? '' : '3. '}Run Processor</h3>
    }
    <Grid container xs={12} spacing={0} sx={{mt: 2}}>
        <Grid item xs={12}>
          <Button disabled={false && isProcessing} sx={{width: '100%'}} variant="outlined" color="primary" component="span" onClick={() => handleRerunAllTransformers()}>
            <AddTaskIcon sx={{mr :1}} />
            {transformerInfo.runs_per_file ? 'Reprocess All' : transformerInfo.label }
          </Button>
        </Grid>
    </Grid>
    <Grid container xs={12} spacing={0} sx={{mt: 1}}>
        <Grid item sx={{ml: 0}} xs={12}>
          {errorCount > 0 && transformerInfo.runs_per_file && 
            <Button disabled={false && isProcessing} sx={{width: '100%'}} variant="outlined" color="error" component="span" onClick={() => handleRerunErrored()}>
              <ErrorIcon sx={{mr: 1}} />
              Reprocess Errored ({errorCount}) 
            </Button>
          }
        
        </Grid>
      </Grid>
  </Box>
  </Box>)
}

export default TransformerResultDetail;
